import { render } from "./ThemeMenu.vue?vue&type=template&id=a997db5c"
import script from "./ThemeMenu.vue?vue&type=script&lang=js"
export * from "./ThemeMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__